import { gql } from '@apollo/client';

export const GET_LEGAL_PERSON_VERIFICATION = gql`
    query AllPersonalVerification(
        $id: String
        $receivedStartDate: String
        $receivedEndDate: String
        $status: String
        $verificationResult: String
    ) {
        allLegalPersonVerification(
            id: $id,
            receivedStartDate: $receivedStartDate,
            receivedEndDate: $receivedEndDate,
            status: $status,
            verificationResult: $verificationResult,
        ) {
            id
            corporateName
            corporateNumber
            legalPersonVerification_verificationId
            legalPersonVerification_verificationPublicId
            legalPersonVerification_receivedDate
            legalPersonVerification_updatedDate
            legalPersonVerification_verificationDate
            legalPersonVerification_verificationMethod
            legalPersonVerification_status
            legalPersonVerification_result
            legalPersonVerification_reasonCode
            legalPersonVerification_reasonTarget
            legalPersonVerification_reasonDetailFields
            legalPersonVerification_verificationMemo
            personalVerification_verificationId
            personalVerification_verificationPublicId
            personalVerification_receivedDate
            personalVerification_updatedDate
            personalVerification_verificationDate
            personalVerification_verificationDocumentType
            personalVerification_verificationMethod
            personalVerification_status
            personalVerification_result
            personalVerification_reasonCode
            personalVerification_reasonTarget
            personalVerification_reasonDetailFields
            letterOfAttorney_verificationId
            letterOfAttorney_verificationPublicId
            letterOfAttorney_receivedDate
            letterOfAttorney_updatedDate
            letterOfAttorney_verificationDate
            letterOfAttorney_verificationMethod
            letterOfAttorney_status
            letterOfAttorney_result
            letterOfAttorney_reasonCode
            letterOfAttorney_reasonTarget
            letterOfAttorney_reasonDetailFields
            amlRiskCheck_amlRiskCheckId
            amlRiskCheck_status
            amlRiskCheck_result
            amlRiskCheck_resultType
            amlRiskCheck_resultMatches
            amlRiskCheck_countFound
            amlRiskCheck_createdDate
            amlRiskCheck_completedDate
            amlRiskCheck_updatedDate
            snailMailVerification_snailMailRequestId
            snailMailVerification_inquiryNumber
            snailMailVerification_result
            snailMailVerification_deliveryStatus
            snailMailVerification_deliveryStatusDetail
            snailMailVerification_deliveryStatusCreatedDate
            snailMailVerification_deliveryStatusUpdatedDate
            snailMailVerification_createdDate
            snailMailVerification_updatedDate
        }
    }`;
